import type { SVGProps } from 'react';

const Coins = (props?: SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.72064 9.25V6.5M20.2206 6.5V10.5C20.2206 10.9324 19.7502 11.3281 18.9706 11.6335M20.2206 6.5C20.2206 7.4665 17.8701 8.25 14.9706 8.25C12.0711 8.25 9.72064 7.4665 9.72064 6.5M20.2206 6.5C20.2206 5.5335 17.8701 4.75 14.9706 4.75C12.0711 4.75 9.72064 5.5335 9.72064 6.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.2206 13.5V17.5C16.2206 18.4665 13.8701 19.25 10.9706 19.25C8.07115 19.25 5.72064 18.4665 5.72064 17.5V13.5M16.2206 13.5C16.2206 14.4665 13.8701 15.25 10.9706 15.25C8.07115 15.25 5.72064 14.4665 5.72064 13.5M16.2206 13.5C16.2206 12.5335 13.8701 11.75 10.9706 11.75C8.07115 11.75 5.72064 12.5335 5.72064 13.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Coins;
